module.exports = __webpack_public_path__ + "front/img/b14.c72a421c.jpg";